import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import * as themes from "../themes";
import { createContextHook } from "./utilities";
var ref = _sliced_to_array(createContextHook({
    displayName: "Brand"
}), 2);
export var context = ref[0], use = ref[1];
var ProviderState = function(param) {
    var children = param.children;
    var ref = useState(themes.blackbird), theme = ref[0], setTheme = ref[1];
    useEffect(function() {
        if (themes.brand === "factbird") {
            setTheme(themes.factbird);
        }
    }, []);
    return /*#__PURE__*/ _jsx(context.Provider, {
        value: {
            name: themes.brand,
            theme: theme
        },
        children: children
    });
};
export var HOC = function(App) {
    return function _(props) {
        return /*#__PURE__*/ _jsx(ProviderState, {
            children: /*#__PURE__*/ _jsx(App, _object_spread({}, props))
        });
    };
};
export default ProviderState;
